import { buildRoute } from '@direct-frontend/modules-router';

export const designRoute = buildRoute('/design');
